import React from 'react';

/**
 * Page hero header — typography + gradient accent line (iq-academic attendance-hero style).
 */
export default function PageHeader({ title, subtitle, action, className = '', accent = true }) {
  return (
    <header className={`vi-page-hero ${className}`.trim()}>
      <div className="vi-page-hero__text">
        <h1 className="vi-page-title">{title}</h1>
        {accent && <span className="vi-page-title-accent" aria-hidden />}
        {subtitle && <p className="vi-page-subtitle">{subtitle}</p>}
      </div>
      {action && <div className="vi-page-header__actions">{action}</div>}
    </header>
  );
}